import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import { PageLoading } from '@/shared/components/feedback/PageLoading';

const HomePage = lazy(() => import('@/pages/HomePage').then((m) => ({ default: m.HomePage })));
const LoginPage = lazy(() => import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('@/pages/RegisterPage').then((m) => ({ default: m.RegisterPage })));
const UnauthorizedPage = lazy(() => import('@/pages/UnauthorizedPage').then((m) => ({ default: m.UnauthorizedPage })));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));
const ContactPage = lazy(() => import('@/pages/ContactPage').then((m) => ({ default: m.ContactPage })));
const ComponentShowcase = lazy(() =>
  import('@/features/dev/ComponentShowcase').then((m) => ({ default: m.ComponentShowcase }))
);

const homeElement = (
  <Suspense fallback={<PageLoading />}>
    <HomePage />
  </Suspense>
);

export const appRoutes = (
  <>
    <Route path="/" element={homeElement} />
    <Route path="/dashboard" element={homeElement} />
    <Route path="/analytics" element={homeElement} />
    <Route path="/projects/:projectId" element={homeElement} />
    <Route path="/projects/:projectId/dashboard" element={homeElement} />
    <Route path="/projects/:projectId/analytics" element={homeElement} />
    <Route path="/interventions/:interventionSlug" element={homeElement} />
    <Route path="/interventions/:interventionSlug/dashboard" element={homeElement} />
    <Route path="/interventions/:interventionSlug/analytics" element={homeElement} />
    <Route
      path="/login"
      element={
        <Suspense fallback={<PageLoading />}>
          <LoginPage />
        </Suspense>
      }
    />
    <Route
      path="/register"
      element={
        <Suspense fallback={<PageLoading />}>
          <RegisterPage />
        </Suspense>
      }
    />
    <Route
      path="/unauthorized"
      element={
        <Suspense fallback={<PageLoading />}>
          <UnauthorizedPage />
        </Suspense>
      }
    />
    <Route
      path="/dev/showcase"
      element={
        <Suspense fallback={<PageLoading />}>
          <ComponentShowcase />
        </Suspense>
      }
    />
    <Route path="/contact" element={
      <Suspense fallback={<PageLoading />}>
        <ContactPage />
      </Suspense>
    } />
    <Route
      path="*"
      element={
        <Suspense fallback={<PageLoading />}>
          <NotFoundPage />
        </Suspense>
      }
    />
  </>
);
